import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import InfoPageLink from '../../../info-page-link';

import * as S from './styles';
import { IconInfoOutlined } from '@prisjakt/ui/icon';

type Props = { className?: string };

export const AboutReviewsLink = (props: Props) => {
  const { market, t } = useContext(AppContext);

  return (
    <S.About className={props.className}>
      <IconInfoOutlined size={16} />
      <InfoPageLink id={market.infoPageMap?.aboutReviews}>
        {t('reviews', 'reviews.about-reviews')}
      </InfoPageLink>
    </S.About>
  );
};
